export default __webpack_public_path__ + "static/to-5e692d78305b5ce632f670084113c673.svg";